module.exports = __webpack_public_path__ + "img/swiper.5a9d1cdb.jpg";